import { Badge } from "@/components/ui/badge";
import { GenericType } from "@/types";

export const ReactTableCell = ({ header, value }: GenericType) => {
  switch (header) {
    case "status": {
      return (
        <Badge variant={value ? "default" : "destructive"}>
          {value ? "Active" : "Inactive"}
        </Badge>
      );
    }
    default: {
      return <span>{value}</span>;
    }
  }
};
